<template>
  <div class="modal-video" @click="closeModalVideo">
    <div class="modal-video-close icon-otw_icon_arrow_close2" @click="closeModalVideo"></div>
    <div class="video-modal">
      <h3 class="modal-title">{{video.name}}</h3>
      <div @click.stop calss="video-modal-box">
        <vueVimeoPlayer
          :video-id="video.path.split('.com/')[1]"
          ref="player"
          :video-url="video.path"
          autoplay="true"
          v-if="video.type === 'link/vm'"
        ></vueVimeoPlayer>
        <youtube
          v-if="video.type === 'link/yt'"
          :video-id="YouTubeGetID(video.path)"
          :player-vars="{ autoplay : 1}"
          ref="youtube"
          :resize ="true"
          :fitParent="true"
        ></youtube>
      </div>
    </div>
  </div>
</template>

<script>
import { vueVimeoPlayer } from "vue-vimeo-player";

export default {
  name: "VideoModal",
  props: ["video"],
  components: {
    vueVimeoPlayer,
  },
  methods: {
    closeModalVideo() {
      this.$emit("closeModalVideo");
    },
    YouTubeGetID(url){
      var ID = '';
      url = url.replace(/(>|<)/gi,'').split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/);
      if(url[2] !== undefined) {
        ID = url[2].split(/[^0-9a-z_-]/i);
        ID = ID[0];
      }
      else {
        ID = url;
      }
        return ID;
    }
  },
};
</script>


<style lang="scss" scoped>
.modal-video {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.85);
  display: flex;
  justify-content: center;
  z-index: 9999;
}

.modal-video-close {
  position: absolute;
  top: 30px;
  right: 50px;
  cursor: pointer;
  z-index: 9999;
}

.modal-video-close:before {
  color: #fff;
  font-size: 20px;
}

.modal-video-close:hover:before {
  color: $light-grey;
}

.video-modal {
  margin-top: 5%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.modal-title {
  text-align: center;
  //color:$main-color;
  color: #fff;
  font-size: 30px;
  font-family: $font-bold;
  font-weight: 700;
  margin-bottom: 40px;
  padding:0 20px;
}

.video-modal-box {
  width:100%;
}


@media screen and (max-width: 768px) {
  .video-modal {
    width:100%; 
  } 
}
</style>